






import { defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { ContentSet, InputContentSetUpdate } from "@scrile/api-provider/dist/api/ContentSetProvider";
import BaseSwitch from "@/components/BaseSwitch";

export default defineComponent({
  name: "AllowCommentsToggle",
  components: { BaseSwitch },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const status = ref(props.postData.allowReviews);

    watch(
      status,
      debounce(value => {
        const data: Omit<InputContentSetUpdate, "id"> = {
          allowReviews: value,
        };
        emit("partialUpdate", { data });
      }, 500)
    );

    return { status };
  },
});
